import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { RideHistoryActions } from './ride-history.actions';
import { RideHistoryPartialStoreState } from './ride-history.reducer';
import * as RideHistorySelectors from './ride-history.selectors';

@Injectable()
export class RideHistoryFacade {
    rides$ = this.store.select(RideHistorySelectors.getRides);
    loading$: Observable<boolean> = this.store.select(RideHistorySelectors.getLoading);
    startDate$: Observable<Date> = this.store.select(RideHistorySelectors.getStartDate);
    endDate$: Observable<Date> = this.store.select(RideHistorySelectors.getEndDate);
    minStartDate$: Observable<Date> = this.store.select(RideHistorySelectors.getMinStartDate);
    minEndDate$: Observable<Date> = this.store.select(RideHistorySelectors.getMinEndDate);
    maxStartDate$: Observable<Date> = this.store.select(RideHistorySelectors.getMaxStartDate);
    maxEndDate$: Observable<Date> = this.store.select(RideHistorySelectors.getMaxEndDate);
    diff$: Observable<number> = this.store.select(RideHistorySelectors.getDateDiff);

    constructor(
        private store: NgRedux<RideHistoryPartialStoreState>,
        private actions: RideHistoryActions
    ) {}

    fetchRideHistory(start: Date, end: Date, token) {
        const payload = { start, end, token };

        return this.store.dispatch(this.actions.fetchRideHistory(payload));
    }

    setStartDate(date: Date) {
        this.store.dispatch(this.actions.setStartDate(date));
    }

    setEndDate(date: Date) {
        this.store.dispatch(this.actions.setEndDate(date));
    }
}
